
















































import { Vue, Component, Prop,Ref } from 'vue-property-decorator'
import { QFile } from 'quasar'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import FileCard from 'components/presenter/item/FileFolderCard.vue'
import api from 'src/assets/api/gql'
import rest from 'src/assets/api/rest'
import ItemAttachments from 'src/graphql/item/ItemAttachments.gql'
import ItemAttachmentUploadStart from 'src/graphql/item/ItemAttachmentUploadStart.gql'
import ItemAttachmentUploadComplete from 'src/graphql/item/ItemAttachmentUploadComplete.gql'
import ItemAttachmentDelete from 'src/graphql/item/ItemAttachmentDelete.gql'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    FileCard
  }
})
export default class ItemFileFolder extends Vue {
  progress: number | null = null
  loading = false
  files: Json[] = []

  @Prop()
  readonly item!: Item

  @Prop()
  readonly accept!: string

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly input!: QFile

  get filesFiltered () {
    if (this.accept) {
      const extensions = this.accept.split(/[,\s]+/).filter(e => e.startsWith('.'))
      const types = this.accept.split(/[,\s]+/).filter(e => !e.startsWith('.'))
      if (types.includes('image/*')) {
        extensions.push('.png', '.jpg', '.jpeg', '.gif', '.bmp', '.webp')
      }
      const pattern = '(\\' + extensions.join('|\\') + ')$'
      const re = RegExp(pattern, 'i')
      return this.files.filter(f => re.test(f.src))
    } else {
      return this.files
    }
  }

  show () {
    this.progress = null
    this.load()
    this.dialog.show()
  }

  hide () {
    this.dialog.hide()
  }

  async load () {
    this.files = []
    this.loading = true
    const { data: { itemAttachments: { nodes: files } } } = await api.query({
      query: ItemAttachments,
      variables: { itemId: this.item.id }
    })
    this.loading = false
    this.files = files.sort((a: Json, b: Json) => b.id - a.id)
  }

  async upload (file: File) {
    this.progress = 0

    let size = 0
    let type = null
    const form = new FormData()
    if (file.type.split('/').shift() === 'image') {
      const reduce = require('image-blob-reduce')()
      const blob = await reduce.toBlob(file, { max: 1920 })
      size = blob.size
      type = blob.type
      form.append('file', blob, file.name)
    } else {
      size = file.size
      type = file.type
      form.append('file', file)
    }

    const itemId = this.item.id
    const createdAt = new Date()
    const name = file.name

    const { data: { itemAttachmentUploadStart: { jwtToken } } } = await api.query({
      query: ItemAttachmentUploadStart,
      variables: {
        input: { itemId, size, type, name }
      }
    })
    const response = await rest.upload('/api/file/upload', form, jwtToken, (event) => {
      this.progress = event.loaded / event.total
    })
    const { id, src } = JSON.parse((response.target as XMLHttpRequest)?.responseText)
    await api.mutate({
      query: ItemAttachmentUploadComplete,
      variables: {
        input: { src }
      }
    })

    this.progress = null
    this.files.unshift({ id, itemId, createdAt, type, size, src })
    this.select(this.files[0])
  }

  async remove (file: Json) {
    this.files.splice(this.files.indexOf(file), 1)
  }

  select (file: Json) {
    this.$emit('file-select', file)
  }
}
